import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../locales/en/en.json";
import errorsEn from "../locales/en/errorsEn.json";

const resources = {
  en: {
    translation: {
      ...en,
      ...errorsEn,
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
    format: function (value, format, lng) {
      if (format === "uploadFileErrorCountSufix") {
        return value > 10 ? "" : `(${value} Cases)`;
      }
      return value;
    },
  },
});

export default i18n;
